<template>
  <div :id="reaction.id">
    <XDateType
      v-if="showDateType"
      :label="labelIcon('fa/regular/gift-card')"
      icon="fa/regular/gift-card"
      :date="reaction.relativeDate"
    />

    <XCard class="py-6 px-4">
      <div
        v-if="reaction.data.hasOwnProperty('name')"
        class="py-2 px-3 text-center"
      >
        <div class="font-semibold text-lg mb-2">
          {{ $t('event.timeline.raffle.reaction.won') }}
        </div>

        <div class="mt-2 mb-4">
          {{ reaction.data.name }}
        </div>

        <XLazyMedia
          :media="reaction.data.image[0]"
          :mediaClass="[$style.media]"
        />
      </div>

      <div
        v-else
        class="py-2 px-3 text-center"
      >
        <div class="font-semibold text-lg mb-2">
          {{ $t('event.timeline.raffle.reaction.lost') }}
        </div>

        <XLazyMedia
          :media="reaction.data.image[0]"
          :mediaClass="[$style.media]"
        />

        <div class="mt-2 font-semibold">
          {{ reaction.data.message }}
        </div>
      </div>
    </XCard>
  </div>
</template>

<script>
import ReactionMixin from './ReactionMixin'

export default {
  mixins: [
    ReactionMixin
  ]
}
</script>

<style lang="scss" module>
.media {
  width: auto !important;
}
</style>
